<template>
	<component :is="component" v-if="component" :data="data" :visible="visible" :ready="ready" />
</template>

<script>
export default {
	name: 'dynamic-component',
	props: ['data', 'folder', 'componentName'],
	data() {
		return {
			visible: true,
			ready: true,
			component: null,
			toDestroy: false
		}
	},
	computed: {
		number() {
			if (typeof this.data.component_id === 'undefined') return '';
			return parseInt(this.data.component_id.replace('component-', ''));
		},
		componentFolder() {
			return this.folder || 'blocks';
		},
		loader() {
			if (!this.type) {
				return null
			}
			return () => import(`@/components/${this.componentFolder}/${this.type}`)
		},
		type() {
			return (typeof this.componentName !== 'undefined') ? this.componentName : this.$options.filters.componentName(this.data.acf_fc_layout)
		}
	},
	methods: {
		reset() {
			this.component = null;
		}
	},
	mounted() {
		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			.catch(() => {
				this.component = false
				if (typeof webpackHotUpdate !== 'undefined') console.log('Missing component: ' + this.data.acf_fc_layout)
			})
	},
	watch: {
		'$route': 'reset'
	}
}
</script>